<div class="cosmos-edit-user__form">
  <div class="cosmos-edit-user__title-close-wrapper">
    <div class="cosmos-edit-user__title-close-wrapper__title">
      Edit User Details
    </div>
    <div class="cosmos-edit-user__title-close-wrapper__button">
      <button
        (click)="discardForm()"
        class="cosmos-edit-user__title-close-wrapper__button"
      >
        <mat-icon>
          <span>close</span>
        </mat-icon>
      </button>
    </div>
  </div>
  <form [formGroup]="_editUserForm">
    <input
      formControlName="username"
      label="Username"
      class="cosmos-edit-user__form__input"
    >
    <input
      formControlName="email"
      label="Email"
      class="cosmos-edit-user__form__input"
    >
    <cosmos-date-picker formControlName="dateTime"></cosmos-date-picker>
  </form>
  <div class="cosmos-edit-user__form__buttons">
    <button
      (click)="discardForm()"
      type="button"
      class="cosmos-edit-user__form__buttons__cancelButton"
    >
      Cancel
    </button>
    <button
      [disabled]="!_editUserForm.valid"
      (click)="submitForm()"
      type="submit"
      class="cosmos-edit-user__form__buttons__addButton"
    >
      Save
    </button>
  </div>
</div>
